<template>
  <div class="uploader">
    <van-field name="uploader" :label="title">
      <template #input>
        <van-uploader v-model="imagePath"
                      :max-size="maxSize"
                      :before-read="beforeRead"
                      :after-read="onRead"
                      :before-delete="deleteFile"
                      :max-count="1"
                      @oversize="onOversize"/>
      </template>
    </van-field>
  </div>
</template>
<script>
import {Toast} from 'vant'
import {getImageOss, changeOssUrl, getOssToken} from '../../../api/order'
import OSS from 'ali-oss'
import {getFileRealPath} from "../../../api/util";

export default {
  name: 'uploader',
  props: {
    imgUrl: {
      type: String,
      default: ''
    },
    id: {
      type: Number,
      default: 0,
    },
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      maxSize: 40960 * 1024,
      imageList: [],
      imagePath: [],
    }
  },
  created() {
    this.initPicture()
  },
  methods: {
    initPicture() {
      if (this.imgUrl !== '' && typeof this.imgUrl !== 'undefined') {
        this.imagePath.push({
          url: this.imgUrl,
          status: ''
        })
        this.$forceUpdate()
      }
    },
    onOversize() {

    },
    onClickLeft() {
      this.$router.push('/my')
    },
    beforeRead (file) {
      if (file.length > 1) {
        for (const i in file) {
          if (file[i].type !== 'image/jpeg' && file[i].type !== 'image/png' && file[i].type !== 'image/jpg') {
            Toast('请上传图片')
            return false
          }
        }
      } else {
        if (file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/jpg') {
          Toast('请上传图片')
          return false
        }
      }
      return true
    },
    deleteFile (file, index) {
      this.$emit("changeImage", "")
      this.imagePath = []
    },
    onRead(file) {
      this.uploadImg(file.file)
    },
    async uploadImg (file) {
      this.imagePath = [{
        url: '',
        status: 'uploading',
        message: '上传中...',
      }]
      let fileSuffix = ''
      if (file.type === 'image/jpeg') {
        fileSuffix = 'jpeg'
      }
      if (file.type === 'image/png') {
        fileSuffix = 'png'
      }
      if (file.type === 'image/jpg') {
        fileSuffix = 'jpg'
      }
      console.log("filel.......", file)
      await getOssToken({ file_suffix: fileSuffix }).then((res) => {
        if (res.data.data) {
          const ossData = res.data.data
          const client = new OSS({
            region: 'oss-' + ossData.region_id,
            accessKeySecret: ossData.access_secret,
            accessKeyId: ossData.access_id,
            stsToken: ossData.secret_token,
            bucket: ossData.bucket
          })
          client.put(ossData.file_name, file).then((result) => {
            if (result && result.url) {
              getFileRealPath({file_id: ossData.file_id}).then((res) => {
                if (res.data.data && res.data.data.file_url_original) {
                  this.$emit("changeImage", ossData.file_id)
                  this.imagePath = [{
                    url: res.data.data.file_url_original,
                    status: '',
                    id: ossData.file_id,
                    name: ossData.file_name
                  }]
                  this.$forceUpdate()
                }
              })

            }
          })
        }
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/components/uploader.vue